import { useState } from "react";
import { Play } from "lucide-react";

export const VideoEmbed = ({ video, testid }) => {
  const [on, setOn] = useState(false);
  return (
    <div className="mt-10 grid gap-6 lg:grid-cols-12 items-center">
      <div className="lg:col-span-8 relative aspect-video overflow-hidden bg-ink rounded-sm">
        {on ? (
          <iframe src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`} title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
            className="absolute inset-0 h-full w-full" data-testid={`${testid}-iframe`} />
        ) : (
          <button type="button" onClick={() => setOn(true)} data-testid={`${testid}-play`} aria-label={`Play video: ${video.title}`}
            className="group absolute inset-0">
            <img src={video.thumb} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
            <span className="absolute inset-0 bg-ink/35 group-hover:bg-ink/20 transition-colors" />
            <span className="absolute inset-0 grid place-items-center">
              <span className="grid h-20 w-20 place-items-center rounded-full bg-brass text-ink shadow-xl transition-transform group-hover:scale-110">
                <Play className="h-8 w-8 translate-x-0.5" fill="currentColor" />
              </span>
            </span>
          </button>
        )}
      </div>
      <div className="lg:col-span-4">
        <p className="eyebrow text-cobalt mb-3">Watch the walkthrough</p>
        <p className="font-wide font-extrabold text-2xl leading-tight">{video.heading}</p>
        <p className="mt-3 text-slate-600 leading-relaxed">{video.caption}</p>
        <a href={`https://www.youtube.com/watch?v=${video.id}`} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-youtube-link`}
          className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-cobalt link-underline">Watch on YouTube</a>
      </div>
    </div>
  );
};
